//  Testing constants
export const tooltipChildTestId = 'tooltip-test-children';
export const tooltipTestId = 'tooltip-test';
export const tooltipTestProps = {
  arrow: true,
  text: 'Tooltip',
  styles: {},
};
